import React from 'react';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

export const DropdownChevronUpGroup: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('#696D70', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <g transform="rotate(180 8 8.5)">
        <path
          d="M12 7.16656L11.06 6.22656L8 9.2799L4.94 6.22656L4 7.16656L8 11.1666L12 7.16656Z"
          fill={fillColor}
        />
      </g>
    </g>
  );
};

export const DropdownChevronUpSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <DropdownChevronUpGroup {...props} />
    </svg>
  );
};
